<template>
    <div>
        <div class="row" v-show="basicData">
            <div class="col-md-12 ">
                <div class="icheck">
                    <label for="basic_data">
                        <input
                            type="checkbox"
                            @change="basicDataChange"
                            data-test="basic_data"
                            name="basic_data"
                            ref="basic_data"
                            required
                            v-model="basic_data"
                        >
                      {{ trans('providerController.basic_data') }}
                    </label>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="holder">{{  trans('bank_account.holder_name')  }}</label>
                    <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            name="holder"
                            data-test="holder"
                            ref="holder"
                            :placeholder="'*' + trans('bank_account.holder_name')"
                            v-model="bankModel.holder"
                            required
                        >
                        <div class="input-group-addon" ref="holder_icon"><font-awesome-icon icon="user" /></div>
                    </div>
                    <span v-html="errorNotFoundHolder"></span>
                </div>
            </div>
        </div>
        <!-- Bank document type -->
        <div class="row">
            <div class="col-md-5">
                <div class="icheck">
                    <div class="form-group radio-group">
                        <input
                            type="radio"
                            name="person_type"
                            id="individual"
                            value="individual"
                            @change="radioChange"
                            v-model="bankModel.person_type"
                        >
                        <label
                            class="radio-label"
                            for="individual"
                        >
                          {{ trans("bank_account.individual") }}
                        </label>
                        <div class="help-block with-errors"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <div class="icheck">
                    <div class="form-group radio-group">
                        <input
                            type="radio"
                            name="person_type"
                            id="coorporative"
                            value="company"
                            @change="radioChange"
                            v-model="bankModel.person_type"
                        >
                        <label
                            class="radio-label"
                            for="coorporative"
                        >
                          {{ trans("bank_account.company") }}
                        </label>
                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-md-12" id="individual_container">
                <div class="form-group">
                    <label for="document_individual">{{ trans('providerController.cpf') + '*' }}</label>
                    <div class="input-group">
                        <input
                            v-if="cpfMask"
                            type="tel"
                            class="form-control cpf"
                            v-mask="['###.###.###-##']"
                            name="document_individual"
                            ref="bank_document_individual"
                            :placeholder=" trans('providerController.cpf')"
                            v-model="bankModel.document_individual"
                        >
                      <input
                            v-else
                            type="tel"
                            class="form-control cpf"
                            name="document_individual"
                            ref="bank_document_individual"
                            :placeholder=" trans('providerController.cpf')"
                            v-model="bankModel.document_individual"
                        >
                        <div class="input-group-addon" ref="bank_document_individual_icon"><font-awesome-icon icon="user" /></div>
                    </div>
                    <span v-if="lang == 'pt-br'" v-html="errorNotFoundCPF"></span>
                    <span v-else></span>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 hidden" id="company_container">
                <div class="form-group">
                    <label for="document_company">{{ trans('providerController.cnpj') + '*'  }}</label>
                    <div class="input-group">
                        <input
                            v-if="cpfMask"
                            type="tel"
                            class="form-control cnpj"
                            v-mask="['##.###.###/####-##']"
                            name="document_company"
                            ref="document_company"
                            id="document_company"
                            :placeholder="trans('providerController.cnpj')"
                            v-model="document_company"
                        >
                      <input
                          v-else
                          type="tel"
                          class="form-control cnpj"
                          name="document_company"
                          ref="document_company"
                          id="document_company"
                          :placeholder="trans('providerController.cnpj')"
                          v-model="document_company"
                      >
                        <div class="input-group-addon" ref="document_company_icon"><font-awesome-icon icon="user" /></div>
                    </div>
                    <span v-if="lang == 'pt-br'" v-html="errorNotFoundCPF"></span>
                    <span v-else></span>
                </div>
            </div>
        </div>
        <!-- Bank document type -->

        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="bank_id"> {{ trans("provider.bank_list") }}</label>
                    <select
                        class="select form-control"
                        id="bank_id"
                        @change="onChangeBank"
                        name="bank_id"
                        data-test="bank_account"
                        style="width: 100%;"
                        v-model="bankModel.bank_id"
                    >
                        <option selected></option>
                        <option v-for="bank in bank_list" :key="bank.id" :value="bank.id">
                            {{ bank.code + " - " +  bank.name }}
                        </option>
                    </select>
                    <div class="help-block with-errors"></div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12" v-if="agency_digit_mask">
                <span>{{ trans("provider.agency_no_digit")}}</span>
            </div>
        </div>

        <div class="row" v-if="agency_mask">
            <div class="col-md-9">
                <div class="form-group">
                    <label for="agency">{{ trans("provider.agency") }}</label>
                    <div class="input-group">
                        <input
                            type="tel"
                            v-mask="[agency_mask]"
                            class="form-control"
                            ref="agency"
                            name="agency"
                            data-test="agency"
                            maxlength="8"
                            minlength="2"
                            :placeholder="'*' + trans('provider.agency')"
                            v-model="bankModel.agency"
                        >
                        <div class="input-group-addon" ref="agency_icon"><span class="fa fa-bank"></span></div>
                    </div>
                    <span v-html="errorNotFoundAgency"></span>
                </div>
            </div>

            <div class="col-md-3" v-if="agency_digit_mask">
                <div class="form-group">
                    <label for="agency_digit">{{ trans('provider.digit') }}</label>
                    <div class="input-group">
                        <input type="tel" v-mask="[agency_digit_mask]" class="form-control" ref="agency_digit" data-test="agency_digit"  name="agency_digit" maxlength="1" minlength="1" placeholder="*" v-model="bankModel.agency_digit">
                        <div class="input-group-addon" ref="agency_digit_icon"><span class="fa fa-bank"></span></div>
                    </div>
                    <span v-html="errorNotFoundAgencyDigit"></span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label class="control-label" for="account">
                        {{ trans('provider.account_type_grid') +" *" }}
                    </label>
                    <select class="form-control" id="account_type" data-test="bank_account_type" name="account_type" v-model="bankModel.account_type">
                        <option v-for="account_type in account_types" :key="account_type.id" :value="account_type.id">
                            {{ account_type.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12" v-if="account_digit_mask">
                <span>{{ trans('provider.agency_no_digit') }}</span>
            </div>
        </div>

        <div class="row">
            <div class="col-md-9">
                <div class="form-group">
                    <label for="account">{{ trans('provider.account') }}</label>
                    <div class="input-group">
                      <input
                          type="tel"
                          v-mask="[account_mask]"
                          class="form-control"
                          ref="account"
                          name="account"
                          data-test="account"
                          maxlength="12"
                          minlength="2"
                          :placeholder="'* ' + trans('provider.account') "
                          v-model="bankModel.account"
                      >
                      <div class="input-group-addon" ref="account_icon"><span class="fa fa-bank"></span></div>
                    </div>
                    <span v-html="errorNotFoundAccount"></span>
                </div>
            </div>
            <div class="col-md-3" v-if="account_digit_mask">
                <div class="form-group">
                    <label for="account_digit">{{ trans('provider.digit') }}</label>
                    <div class="input-group">
                        <input
                            type="tel"
                            v-mask="[account_digit_mask]"
                            class="form-control"
                            ref="account_digit"
                            data-test="account_digit"
                            name="account_digit"
                            maxlength="1"
                            minlength="0"
                            placeholder="*"
                            v-model="bankModel.account_digit"
                        >
                        <div class="input-group-addon" ref="account_digit_icon"><span class="fa fa-bank"></span></div>
                    </div>
                    <span v-html="errorNotFoundAccountDigit"></span>
                </div>
            </div>
        </div>
        <div class="row" v-if="isGatewayStripe">
            <div class="col-md-12">
                <div class="form-group">
                    <label>{{ trans('providerController.birthdate') }}</label>
                    <div class="input-group">
                        <DatePicker
                            v-model="bankModel.birthday_date"
                            :lang="lang"
                            format="DD/MM/YYYY"
                            placeholder="DD/MM/YYYY"
                            valueType="DD/MM/YYYY"
                            ref="birthday_date"
                            name="birthday_date"
                        />
                    </div>
                    <span class="label label-warning">{{ 'user_provider_web.min_age' }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import Vuetify from 'vuetify';
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import axios from 'axios';
import Swal from 'sweetalert2';
import 'vue2-datepicker/locale/pt-br';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/index.css';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faUser);
import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask)

Vue.use(Vuetify);

Vue.use(VueFormWizard);

export default {
    components: { Multiselect, DatePicker, FontAwesomeIcon },
    props: {
        bankModel: Object,
        base_url: String,
        bank_list: Array,
        providerId: Number | String,
        account_types: Array,
        isGatewayStripe: Boolean,
        getBasicData: Function,
        cpfMask: Boolean | String,
        basicData: {
            type: Boolean,
            default: false
        },
    },
	vuetify: new Vuetify(),
    data() {
        return {
            errorNotFoundHolder: "",
			errorNotFoundAgency: "",
			errorNotFoundAgencyDigit: "",
			errorNotFoundAccount: "",
			errorNotFoundAccountDigit: "",
			errorNotFoundBankCNPJ: "",
            errorNotFoundBankCPF: "",
			document_company: null,
            basic_data: true,
            agency_mask: "",
            agency_digit_mask: "",
            account_mask: "###########",
            account_digit_mask: "", 
            lang: ""
        }
    },
    methods: {
        onChangeBank() {
            if (this.bankModel.bank_id) {
                var bank = this.bank_list.find(x => x.id === this.bankModel.bank_id);
                this.agency_mask = '#'.repeat(bank.agency_max_length);
                this.agency_digit_mask = '#'.repeat(bank.agency_digit_max_length);
                this.account_mask = '#'.repeat(bank.account_max_length);
                this.account_digit_mask = '#'.repeat(bank.account_digit_max_length);
            }
        },
        basicDataChange() {
            if (this.getBasicData) {
                this.getBasicData();
            }
        },
        radioChange() {
            var container = '#' + this.bankModel.person_type + '_container';
            var current_container = '';

            switch (this.bankModel.person_type) {
                case 'individual':
                    current_container = '#company_container';
                    break;
                case 'company':
                    current_container = '#individual_container';
                    break;
            }

            $(current_container).fadeOut('slow', function () {
                $(container).fadeIn().removeClass('hidden');

                $(container).children('.form-group > .form-control').focus();
            }).addClass('hidden');
        },
        validate() {
            var valid = true;

            if (this.bankModel.holder) {
                this.errorNotFoundHolder = "";
                this.$refs.holder.style.border = "1px solid rgb(220, 220, 220)";
                this.$refs.holder_icon.style.border = "1px solid rgb(220, 220, 220)";
            } else {
                this.errorNotFoundHolder =
                    '<div class="help-block with-errors"><span>' + this.trans('provider.holder_message') + '</span></div>';
                this.$refs.holder.style.border = "1px solid rgb(169, 68, 66)";
                this.$refs.holder_icon.style.border = "1px solid rgb(169, 68, 66)";
                valid = false;
            }
          if(this.agency_mask ){
            if (this.bankModel.agency ) {
              this.errorNotFoundAgency = "";
              this.$refs.agency.style.border = "1px solid rgb(220, 220, 220)";
              this.$refs.agency_icon.style.border = "1px solid rgb(220, 220, 220)";
            } else {
              this.errorNotFoundAgency =
                  '<div class="help-block with-errors"><span>' + this.trans('provider.agency_message') + '</span></div>';
              this.$refs.agency.style.border = "1px solid rgb(169, 68, 66)";
              this.$refs.agency_icon.style.border = "1px solid rgb(169, 68, 66)";
              valid = false;
            }
          }

          if(this.agency_digit_mask ) {
            if (this.bankModel.agency_digit) {
              this.errorNotFoundAgencyDigit = "";
              this.$refs.agency_digit.style.border = "1px solid rgb(220, 220, 220)";
              this.$refs.agency_digit_icon.style.border = "1px solid rgb(220, 220, 220)";
            } else {
              this.errorNotFoundAgencyDigit =
                  '<div class="help-block with-errors"><span>' + this.trans('provider.digit_message') + '</span></div>';
              this.$refs.agency_digit.style.border = "1px solid rgb(169, 68, 66)";
              this.$refs.agency_digit_icon.style.border = "1px solid rgb(169, 68, 66)";
              valid = false;
            }
          }

            if (this.bankModel.account) {
                this.errorNotFoundAccount = "";
                this.$refs.account.style.border = "1px solid rgb(220, 220, 220)";
                this.$refs.account_icon.style.border = "1px solid rgb(220, 220, 220)";
            } else {
                this.errorNotFoundAccount =
                    '<div class="help-block with-errors"><span>' + this.trans('provider.account_message') + '</span></div>';
                this.$refs.account.style.border = "1px solid rgb(169, 68, 66)";
                this.$refs.account_icon.style.border = "1px solid rgb(169, 68, 66)";
                valid = false;
            }

          if(this.account_digit_mask){
            if (this.bankModel.account_digit) {
              this.errorNotFoundAccountDigit = "";
              this.$refs.account_digit.style.border = "1px solid rgb(220, 220, 220)";
              this.$refs.account_digit_icon.style.border = "1px solid rgb(220, 220, 220)";
            } else {
              this.errorNotFoundAccountDigit =
                  '<div class="help-block with-errors"><span>'+ this.trans('digit_message') + '</span></div>';
              this.$refs.account_digit.style.border = "1px solid rgb(169, 68, 66)";
              this.$refs.account_digit_icon.style.border = "1px solid rgb(169, 68, 66)";
              valid = false;
            }
          }

          if(this.lang == 'pt-br'){
            if (this.bankModel.person_type == "individual") {
                    if (this.bankModel.document_individual) {
                        this.errorNotFoundBankCPF = "";
                        this.$refs.bank_document_individual.style.border = "1px solid rgb(220, 220, 220)";
                        this.$refs.bank_document_individual_icon.style.border = "1px solid rgb(220, 220, 220)";
                    } else {
                        this.errorNotFoundBankCPF =
                            '<div class="help-block with-errors"><span>' + this.trans('provider.cpf_message') + '</span></div>';
                        this.$refs.bank_document_individual.style.border = "1px solid rgb(169, 68, 66)";
                        this.$refs.bank_document_individual_icon.style.border = "1px solid rgb(169, 68, 66)";
                        valid = false;
                    }
            } else {
                if (this.document_company) {
                    this.errorNotFoundBankCNPJ = "";
                    this.$refs.document_company.style.border = "1px solid rgb(220, 220, 220)";
                    this.$refs.document_company_icon.style.border = "1px solid rgb(220, 220, 220)";
                    this.bankModel.document_company = this.document_company;
                } else {
                    this.errorNotFoundBankCNPJ =
                        '<div class="help-block with-errors"><span>' + this.trans('provider.cnpj_message') + '</span></div>';
                    this.$refs.document_company.style.border = "1px solid rgb(169, 68, 66)";
                    this.$refs.document_company_icon.style.border = "1px solid rgb(169, 68, 66)";
                    valid = false;
                }
            }

          }
            return valid;
        },
        async save() {
            Swal.fire({
                text: this.trans('proiderController.saving_bank_account'),
            });
            Swal.showLoading();

            var document = null;
            var key = null;
            var formData = new FormData();
			formData.append('origin', 'web');

            if (this.providerId)
			    formData.append('provider_id', this.providerId);

			formData.append('holder', this.bankModel.holder);
			formData.append('bank_id', this.bankModel.bank_id);
			formData.append('agency', this.bankModel.agency);
			formData.append('agency_digit', this.bankModel.agency_digit);
			formData.append('account', this.bankModel.account);
			formData.append('account_digit', this.bankModel.account_digit);
			formData.append('person_type', this.bankModel.person_type);
			formData.append('account_type', this.bankModel.account_type);

            if (this.bankModel.person_type == 'individual') {
                document = this.bankModel.document_individual;
                key = 'document_individual';
            } else {
                document = this.bankModel.document_company;
                key = 'document_company';
            }	
			formData.append(key, document);

            try {
                var json_result = await axios.post(this.base_url + '/api/v2/provider/wizard/save_bank', formData,
                {
                    crossDomain: true,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            
                if (json_result.data.success == true) {
                    this.providerId = json_result.data.provider.id;
                    Swal.close();
                    return true;
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: json_result.data.errors,
                    });
                    
                    return false;
                }
            } catch(error) {
                alert(error);
                Swal.close();
                return false;
            }
        }
    },
    mounted() {
        this.radioChange();
    },
    created() {
        if (this.bankModel.person_type == 'individual' && 
            this.bankModel.document && 
            !this.bankModel.document_individual) {
            this.bankModel.document_individual = this.bankModel.document;
        } else if (this.bankModel.person_type == 'company' && 
            this.bankModel.document && 
            !this.bankModel.document_company) {
            this.document_company = this.bankModel.document;
        }

        if (!this.bankModel.agency_digit) {
            this.bankModel.agency_digit = '0';
        }

        if (!this.bankModel.account_digit) {
            this.bankModel.account_digit = '0';
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="./register.css"></style>
<style>
@import "https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900";
@import "https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css";
@import "https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css";
</style>